
export * from '../../frontend-js-react-web/__liferay__/index.js';
